import { Button, DatePicker, Form, Input, message, Modal, Radio, Tag, Select, Tree } from "antd";
import React from "react";
import moment from "moment";
import groupBy from "lodash/groupBy";
import first from "lodash/first";
import last from "lodash/last";
import debounce from "lodash/debounce";
import { v4 as uuid } from "uuid";
import Treeview from "./TreeView";
import { useDispatch, useSelector } from "react-redux";
import { fetchKpiAsync } from "src/features/kpi/kpiSlice";
import kpiService from '@services/kpi.service';
import performanceManagementService from "@services/performanceManagement.service";
import { addCounter } from "src/features/performanceManagement/pmSlice";
import transmissionService from "@services/transmission.service";
import { useState } from "react";

const { RangePicker } = DatePicker;
const { Search } = Input;
const controller = new AbortController();

// eslint-disable-next-line
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

/* eslint-disable-next-line */
function updateTreeData(list, key, children) {
  return list.map((node) => {
    if (node.key === key) {
      return { ...node, children };
    }

    if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children),
      };
    }

    return node;
  });
}

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
/* eslint-enable no-template-curly-in-string */

function SearchComponent({ close = () => { } }) {
  const [form] = Form.useForm();
  const [dateForm] = Form.useForm();
  const [dataSourceNodes, setTreeData] = React.useState([
    {
      type: "network",
      title: "Network",
      key: "network",
      isLeaf: true,
    },
    {
      type: "region",
      title: "Regien",
      // key: "huawei",
      key: "region",
      checkable: false,
    },
    {
      type: "subregion",
      title: "Sub Region",
      // key: "huawei",
      key: "subregion",
      checkable: false,
    },
    {
      type: "province",
      title: "Province",
      key: "province",
      checkable: false,
    },
    {
      type: "city",
      title: "City",
      key: "city",
      checkable: false,
    },
    {
      type: "deviceName",
      title: "Device Name",
      key: "deviceName",
      checkable: false,
    },
    {
      type: "resourceName",
      title: "Resource Name",
      key: "resourceName",
      checkable: false,
    },
    {
      type: "site",
      title: "Site",
      key: "site",
      checkable: false,
    },
    {
      type: "sector",
      title: "Sector",
      key: "sector",
      checkable: false,
    },
    {
      type: "cell",
      title: "Cell",
      key: "cell",
      checkable: false,
    },
    {
      type: "band",
      title: "Band",
      key: "band",
      checkable: false,
    },

  ]);
  const [searchQ, setSearchQ] = React.useState("");
  const [searchKPI, setSearchKPI] = React.useState("");
  const [errors, setErrors] = React.useState([]);
  const [selectedKPI, setSelectedKPI] = React.useState([]);
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const dispatch = useDispatch();
  // eslint-disable-next-line
  const { loading, data: kpis } = useSelector((state) => state.kpis);

  // function fetcherKpis() {
  //   dispatch(fetchKpiAsync());
  // }

  // function fetcherRNCs() {
  //   performanceManagementService
  //     .fetchRNC()
  //     .then((res) => {
  //       setTreeData([
  //         ...dataSourceNodes,
  //         {
  //           type: "region",
  //           key: "rnc",
  //           title: "RNC",
  //           children: res.data.reduce((result, item) => {
  //             result.push({
  //               type: "rnc",
  //               title: item,
  //               value: item,
  //               key: "rnc_" + item,
  //             });

  //             return result;
  //           }, []),
  //         },
  //       ]);
  //     })
  //     .catch((e) => console.log(e));
  // }

  const onCheck = (checkedKeys, info) => {
    // console.log(info.checkedNodes);
    setSelectedKPI(checkedKeys);
  };
  const onFinish = async ({ date, ne, kpi, ...values }) => {
    setErrors([]);

    const dates = date.split(" - ");

    ne = first(ne);
    const nes = ne.split("_");
    // const kpiId = first(kpi);

    // const kpiItem = kpis.find((k) => k._id === kpiId);
    const v = {
      startDate: first(dates).replace(/\//g, "-"),
      endDate: last(dates).replace(/\//g, "-"),
      scope: first(nes),
      kpi_id: selectedKPI,
      // counters: kpiItem ? kpiItem.counters || [] : [],
      value:
        first(nes) === "rnc" ||
          first(nes) === "deviceName" ||
          first(nes) === "resourceName"
          ? nes.slice(1, nes.length).join("_")
          : nes[1],
      ...values,
    };

    try {
      const res = await performanceManagementService.fetchKpi2(v);

      //console.log(res.data);
      dispatch(
        addCounter({
          data: [...res.data],
          id: uuid(),
          ...v,
          show: true,
          counterShow: false,
          type: "line",
          color:
            "#" +
            ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0"),
          align: {
            y: "left1",
          },
        })
      );

      close();
    } catch (e) {
      message.error("Action has error",20);
      console.log(e);
    }
  };

  const onFinishFailed = (values) => {
    setErrors(values.errorFields);
  };
  const searchKPIChange = (e) => {
    const { value } = e.target;
    setSearchKPI(value);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = (values) => {
    const { range } = values;
    if (range && range.length)
      form.setFieldsValue({
        date: `${moment(range[0]).format("YYYY/MM/DD HH:mm")} - ${moment(
          range[1]
        ).format("YYYY/MM/DD HH:mm")}`,
      });
    else form.setFieldsValue({ date: null });
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // eslint-disable-next-line
  const onLoadData = ({ key, children, pos, ...rest }) => {
    return new Promise(async (resolve) => {
      if (children) {
        resolve();
        return;
      }

      try {
        const search = key.replace(
          /(rnc|region|province|city|deviceName|resourceName)_(.*)_/g,
          ""
        );

        const steps = pos.split("-");

        let res = null;

        switch (steps.length) {
          case 2:
            // res = await performanceManagementService.fetchRegions({
            //   vendor: search,
            // });

            //   setTreeData((origin) =>
            //   updateTreeData(
            //     origin,
            //     key,
            //     res.data.reduce((result, item) => {
            //       result.push({
            //         type: "region",
            //         title: item.name,
            //         key: "region_" + item.id + "_" + item.name,
            //         value: item.id,
            //         ...item,
            //       });
            //       return result;
            //     }, [])
            //   )
            // );
            if (key === "region") {
              res = await transmissionService.fetchRegions();

              setTreeData((origin) =>
                updateTreeData(
                  origin,
                  key,
                  res.data.reduce((result, item) => {
                    result.push({
                      type: "region",
                      title: item,
                      key: "region_" + item,
                      value: item,
                      isLeaf: true,
                    });
                    return result;
                  }, [])
                )
              );
            } else if (key === "province") {
              res = await transmissionService.fetchProvinces();

              setTreeData((origin) =>
                updateTreeData(
                  origin,
                  key,
                  res.data.reduce((result, item) => {
                    result.push({
                      type: "province",
                      title: item,
                      key: "province_" + item,
                      value: item,
                      isLeaf: true,
                    });
                    return result;
                  }, [])
                )
              );
            } else if (key === "city") {
              res = await transmissionService.fetchCities();

              setTreeData((origin) =>
                updateTreeData(
                  origin,
                  key,
                  res.data.reduce((result, item) => {
                    result.push({
                      type: "city",
                      title: item,
                      key: "city_" + item,
                      value: item,
                      isLeaf: true,
                    });
                    return result;
                  }, [])
                )
              );
            } else if (key === "resourceName") {
              res = await transmissionService.fetchResourceName();

              setTreeData((origin) =>
                updateTreeData(
                  origin,
                  key,
                  res.data.reduce((result, item) => {
                    console.log("item", item);
                    result.push({
                      type: "resourceName",
                      title: item,
                      key: "resourceName_" + item,
                      value: item,
                      isLeaf: true,
                    });
                    return result;
                  }, [])
                )
              );
            } else if (key === "deviceName") {
              res = await transmissionService.fetchDeviceName();

              setTreeData((origin) =>
                updateTreeData(
                  origin,
                  key,
                  res.data.reduce((result, item) => {
                    result.push({
                      type: "deviceName",
                      title: item,
                      key: "deviceName_" + item,
                      value: item,
                      isLeaf: true,
                    });
                    return result;
                  }, [])
                )
              );
            }

            break;
          case 3:
            res = await performanceManagementService.fetchProvinces({
              region: search,
            });

            setTreeData((origin) =>
              updateTreeData(
                origin,
                key,
                res.data.reduce((result, item) => {
                  result.push({
                    type: "province",
                    title: item.name,
                    key: "province_" + item.id + "_" + item.name,
                    value: item.id,
                    ...item,
                  });
                  return result;
                }, [])
              )
            );
            break;
          case 4:
            res = await performanceManagementService.fetchCities({
              province: search,
            });

            setTreeData((origin) =>
              updateTreeData(
                origin,
                key,
                res.data.reduce((result, item) => {
                  result.push({
                    type: "city",
                    title: item.name,
                    key: "city_" + item.id + "_" + item.name,
                    value: item.id,
                    ...item,
                  });
                  return result;
                }, [])
              )
            );
            break;
          case 5:
            res = await performanceManagementService.fetchSites({
              city_id: rest.id || "",
            });

            setTreeData((origin) =>
              updateTreeData(
                origin,
                key,
                res.data.reduce((result, item) => {
                  // if (item.includes(toTitleCase(key)))
                  result.push({
                    type: "sites",
                    title: item.name,
                    key: "sites_" + item.name + "_" + item.name,
                    value: item.name,
                    children: [],
                    ...item,
                  });
                  return result;
                }, [])
              )
            );
            break;
          default:
            break;
        }
      } catch (e) {
        console.log(e);
      } finally {
        resolve();
      }
    });
  };

  React.useEffect(() => {
    if (!isModalVisible) {
      dateForm.resetFields();
    }
    // eslint-disable-next-line
  }, [isModalVisible]);
  const [dataNode, setDataNode] = useState([]);
  const [dataNodeDataSource, setDataNodeDataSource] = useState([]);
  function list_to_tree(list) {
    var map = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i]._id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      node["title"] = node.name;
      node["key"] = node._id;
      if (node.type) {
        node["disableCheckbox"] = true
      }
      if (node.parent !== "0") {
        // if you have dangling branches check that map[node.parentId] exists
        list[map[node.parent]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  function filter(array, text) {
    const getNodes = (result, object) => {
      if (object.name.toLowerCase().indexOf(text.toLowerCase()) > -1) {
        result.push(object);
        return result;
      }

      if (Array.isArray(object.children)) {
        const children = object.children.reduce(getNodes, []);
        // console.log('nodes', nodes)
        // console.log('object', object)
        if (children.length) result.push({ ...object, children });
      }

      return result;
    };
    return array.reduce(getNodes, []);
  }
  React.useEffect(() => {
    // console.log(searchKPI)
    async function fetch() {
      let tree = [];
      // console.log("dataNode",dataNode);
      if (dataNodeDataSource.length === 0) {
        let response = await kpiService.fetchKpi();
        console.log("kpi", response.data);
        setDataNodeDataSource(response.data);
        tree = list_to_tree(response.data);
      }
      else {
        tree = list_to_tree(dataNodeDataSource);
      }
      if (searchKPI.length > 0) {
        const result = filter(tree, searchKPI);
        // console.log("result",result);
        setDataNode(result);
      }
      else {
        setDataNode(tree);
      }
    }
    fetch();


  }, [searchKPI]);

  return (
    <>
      <div className="flex-grow p-5">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          validateMessages={validateMessages}
          className="flex flex-col space-y-3 h-full"
          initialValues={{
            date: "Last Day",
            buket: "1d",
          }}
        >
          <div className="flex space-x-3">
            <Form.Item
              name={"date"}
              label="Date"
              rules={[{ required: true }]}
              className="w-72"
            >
              <Input
                allowClear
                onClick={showModal}
                readOnly
                className="max-w-xs"
              />
            </Form.Item>
            <Form.Item name={"buket"} label="Time buket" rules={[{ required: true }]}>
              <Radio.Group
                options={[
                  { label: "15 mins", value: "15m" },
                  { label: "30 mins", value: "30m" },
                  { label: "Hourly", value: "1h" },
                  { label: "Daily", value: "1d" },
                  { label: "Weekly", value: "7d" },
                  { label: "Monthly", value: "30d" },
                ]}
                optionType="button"
                buttonStyle="solid"
              />
            </Form.Item>
            <Form.Item label="-------">
              <Button type="primary" htmlType="submit">
                Submit Query
              </Button>
            </Form.Item>

          </div>

          <div className="space-x-3 flex-grow flex items-stretch">
            <div className="flex-grow flex flex-col h-full-tree">
              <div className="h-full flex flex-col bg-white rounded border border-gray-200 p-2">
                {/* <Treeview
                  dataSource={dataNode}
                  // handleChange={(v) =>
                  //   form.setFieldsValue({ ...form.getFieldsValue(), kpi: v })
                  // }
                  multiple={false}
                  checkable
                  filter
                  name="kpi"
                /> */}
                <div className="flex flex-col mb-2 p-2">
                  <Search style={{ marginBottom: 8 }} placeholder="Search" onChange={searchKPIChange} />
                </div>
                <Tree
                  checkable
                  onCheck={onCheck}
                  showLine={{ hideLeafIcon: true }}
                  treeData={dataNode}
                />
              </div>
              {/* <Form.Item
                name={"kpi"}
                label="KPI"
                hidden
                rules={[{ required: true }]}
              >
                <input />
              </Form.Item> */}
            </div>
            <div className="flex-grow flex-shrink-0 flex flex-col h-full-tree">
              <div className="h-full flex flex-col bg-white rounded border border-gray-200 p-2">
                <Treeview
                  handleChange={(v) => {
                    form.setFieldsValue({
                      ...form.getFieldsValue(),
                      ne: v,
                    });
                  }}
                  handleFilterData={(
                    q,
                    dataList,
                    setExpandedKeys,
                    setAutoExpandParent,
                    getParentKey
                  ) => {
                    const expandedKeys = dataList
                      .map((item) => {
                        if (
                          (item.title || "")
                            .toLowerCase()
                            .indexOf(q.toLowerCase()) > -1
                        ) {
                          return getParentKey(item.key, dataList);
                        }
                        return null;
                      })
                      .filter(
                        (item, i, self) => item && self.indexOf(item) === i
                      );

                    if (q.length > 0) {
                      setExpandedKeys(expandedKeys);
                      setAutoExpandParent(true);
                    } else {
                      setAutoExpandParent(false);
                    }
                  }}
                  handleSearch={debounce(async (q, setExpandedKeys) => {
                    controller.abort();

                    if (
                      (q.length >= 3 || q.length === 0) &&
                      (q || q === "") &&
                      q !== searchQ
                    ) {
                      setSearchQ(q);
                      setExpandedKeys([]);

                      const resNE = await transmissionService.fetchDeviceName(
                        { q },
                        {
                          signal: controller.signal,
                        }
                      );
                      setTreeData((origin) =>
                        updateTreeData(
                          origin,
                          "deviceName",
                          resNE.data.reduce((result, item) => {
                            result.push({
                              type: "deviceName",
                              title: item,
                              key: "deviceName_" + item,
                              value: item,
                              isLeaf: true,
                            });
                            return result;
                          }, [])
                        )
                      );

                      const resCities = await transmissionService.fetchCities(
                        {
                          q,
                        },
                        {
                          signal: controller.signal,
                        }
                      );
                      setTreeData((origin) =>
                        updateTreeData(
                          origin,
                          "city",
                          resCities.data.reduce((result, item) => {
                            result.push({
                              type: "city",
                              title: item,
                              key: "city_" + item,
                              value: item,
                              isLeaf: true,
                            });
                            return result;
                          }, [])
                        )
                      );

                      const resProvinces =
                        await transmissionService.fetchProvinces(
                          { q },
                          {
                            signal: controller.signal,
                          }
                        );
                      setTreeData((origin) =>
                        updateTreeData(
                          origin,
                          "province",
                          resProvinces.data.reduce((result, item) => {
                            result.push({
                              type: "province",
                              title: item,
                              key: "province_" + item,
                              value: item,
                              isLeaf: true,
                            });
                            return result;
                          }, [])
                        )
                      );

                      const resResourceName =
                        await transmissionService.fetchResourceName(
                          { q },
                          {
                            signal: controller.signal,
                          }
                        );
                      setTreeData((origin) =>
                        updateTreeData(
                          origin,
                          "resourceName",
                          resResourceName.data.reduce((result, item) => {
                            result.push({
                              type: "resourceName",
                              title: item,
                              key: "resourceName_" + item,
                              value: item,
                              isLeaf: true,
                            });

                            return result;
                          }, [])
                        )
                      );
                    }
                  }, 900)}
                  checkable
                  dataSource={dataSourceNodes}
                  loadData={onLoadData}
                  filter
                  multiple={false}
                  name="ne"
                />
              </div>
              <Form.Item
                name={"ne"}
                label="NE"
                hidden
                rules={[{ required: true }]}
              >
                <input />
              </Form.Item>
            </div>
          </div>

          <div className="text-red-500">
            {errors.map((e, i) => (
              <Form.ErrorList key={i} errors={e.errors} />
            ))}
          </div>


        </Form>
      </div >

      <Modal
        title="Date"
        visible={isModalVisible}
        onOk={() => dateForm.submit()}
        onCancel={handleCancel}
        centered
        // footer={null}
        className="max-w-xs"
      >
        <div className="space-y-3">
          <div className="">
            <Form form={dateForm} onFinish={handleOk}>
              <Form.Item name="range">
                <RangePicker
                  showTime={{
                    format: "HH:mm",
                  }}
                />
              </Form.Item>
            </Form>
          </div>
          <div className="space-y-2">
            <Tag
              style={{
                color: "#2f5ec4",
                backgroundColor: "#f0f7ff",
                borderColor: "#a9c4eb",
                cursor: "pointer",
              }}
              onClick={() => {
                form.setFieldsValue({ date: "Last Day" });
                handleCancel();
              }}
            >
              Last Day
            </Tag>
            <Tag
              style={{
                color: "#2f5ec4",
                backgroundColor: "#f0f7ff",
                borderColor: "#a9c4eb",
                cursor: "pointer",
              }}
              onClick={() => {
                form.setFieldsValue({ date: "Last 7 Days" });
                handleCancel();
              }}
            >
              Last 7 Days
            </Tag>
            <Tag
              style={{
                color: "#2f5ec4",
                backgroundColor: "#f0f7ff",
                borderColor: "#a9c4eb",
                cursor: "pointer",
              }}
              onClick={() => {
                form.setFieldsValue({ date: "Last 2 Weeks" });
                handleCancel();
              }}
            >
              Last 2 Weeks
            </Tag>
            <Tag
              style={{
                color: "#2f5ec4",
                backgroundColor: "#f0f7ff",
                borderColor: "#a9c4eb",
                cursor: "pointer",
              }}
              onClick={() => {
                form.setFieldsValue({ date: "Last 3 Weeks" });
                handleCancel();
              }}
            >
              Last 3 Weeks
            </Tag>
            <Tag
              style={{
                color: "#2f5ec4",
                backgroundColor: "#f0f7ff",
                borderColor: "#a9c4eb",
                cursor: "pointer",
              }}
              onClick={() => {
                form.setFieldsValue({ date: "Last 30 Days" });
                handleCancel();
              }}
            >
              Last 30 Days
            </Tag>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SearchComponent;
